// ---------------------------------------------------------------------------
// AppLock — Configuration schema & defaults
// ---------------------------------------------------------------------------
/** AppLock's own meta-keys that are always stored in cleartext. */
export const META_KEYS = [
    'applock_salt',
    'applock_hash',
    'applock_config',
    'applock_version',
];
const DEFAULT_IDLE_EVENTS = [
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
    'click',
];
/**
 * Merge user-supplied config with sensible defaults.
 * Body-dependent defaults (mountPoint) are deferred to runtime.
 */
export function resolveConfig(user) {
    const isEncrypted = user.mode === 'encrypted';
    return {
        mode: user.mode,
        idleTimeout: user.idleTimeout ?? (isEncrypted ? 300 : 900),
        idleEvents: user.idleEvents ?? DEFAULT_IDLE_EVENTS,
        pbkdf2Iterations: user.pbkdf2Iterations ?? 600000,
        encryptedKeys: user.encryptedKeys ?? null,
        cleartextKeys: [
            ...META_KEYS,
            ...(user.cleartextKeys ?? []),
        ],
        storageBackend: user.storageBackend ?? 'localStorage',
        idbDatabaseName: user.idbDatabaseName ?? 'applock',
        idbStoreName: user.idbStoreName ?? 'kv',
        ui: user.ui ?? true,
        mountPoint: user.mountPoint ?? null, // resolved at render time
        lockScreenClass: user.lockScreenClass ?? '',
        appRootSelector: user.appRootSelector ?? '#app',
        lockOnHide: user.lockOnHide ?? isEncrypted,
        clearClipboard: user.clearClipboard ?? false,
        maxAttempts: user.maxAttempts ?? 5,
    };
}
//# sourceMappingURL=config.js.map